import React, {useEffect, useState} from "react";
import LibraryComponent from "../../LibraryComponent/LibraryComponent";
import DroppableList from "../DraggingWrappers/DroppableList";
import classes from '../Merging.module.css'
import PulsingDivWrapper from "../DraggingWrappers/PulsingDivWrapper";
import {useDispatch, useSelector} from "react-redux";
import * as actionTypes from '../../../store/actions/actionTypes'


// The idea is that this approach will eventually replace the current example game.
const ExampleGameTemporary = ({exampleGame, update = () => {}, isMerging, designProblems = [], fromStyles = false, liveEdit = false}) => {
    const problems = useSelector(state => state.modal.merge_modal.problems)
    const userId = useSelector(state => state.auth.userId)
    const [options, setOptions] = useState([])

    const [secondaryGames, setSecondaryGames] = useState(exampleGame
    && Array.isArray(exampleGame.secondary_games)
    && exampleGame.secondary_games.length > 0 ? exampleGame.secondary_games.map((e) => {
        // console.log(exampleGame  secondaryGames)
        return {
            content: <div className={classes.SecondaryGame} key={e.game_name}>{
                e.game_name
            }</div>,
            id: e.game_name + " secondary " + exampleGame.game_id,
            game: e,
            // game: {...e, pattern_secondary_game_user_id: userId},
        }
    }) : []);

    const dispatch = useDispatch();

    const draggingFromGlobal = useSelector(state => state.patternLibrary.dragging)

    useEffect(() => {
        update({id: exampleGame.game_id, secondary: secondaryGames})
    }, [secondaryGames]); // eslint-disable-line react-hooks/exhaustive-deps

    const [select, setSelect] = useState(exampleGame && exampleGame.design_problems ? exampleGame.design_problems.map((problem, index) => ({value: problem, label: `Design Problem ${index + 1}`})) : [])

    useEffect(() => {
        let selectedItems = exampleGame && exampleGame.design_problems
            ? exampleGame.design_problems.map((problem) => {
                let currProblems =  problems || [];

                let index = currProblems.findIndex((p) => {
                    // console.log("p", p)
                    // console.log('Problem', problem)
                    return +p.design_problem_id === +problem;
                });

                return { value: problem, label: `Design Problem ${index + 1}` };
            })
            : []

        selectedItems = selectedItems.filter(item => item.label !== 'Design Problem 0')

        const currOptions = problems.map((item, i) => {
            return {
                value: item.design_problem_id, label: `Design Problem ${i + 1}`
            }
        })
        setOptions(currOptions)

        setSelect(selectedItems);
    }, [exampleGame,  problems]);



    const listName = exampleGame.game_name + exampleGame.game_id;

    return <LibraryComponent uniqueId={exampleGame.game_id}
                             update={update} name={exampleGame.game_name}
                             startDesc={exampleGame.example_description}
                             isMerging={isMerging}
                             startingSelect={select}
                             getOptions={() => options}
                             useSelect
                             fromStyles={fromStyles}
                             liveEdit={liveEdit}
    >
        {/*This is where the secondary games will go. Should Be draggable*/}
        <div style={{width: '100%', gap: 0, display: 'block', paddingRight: '10px'}}>
            <span className={classes.SecondaryTitle}>Games with similar implementation:</span>
            <PulsingDivWrapper active={isMerging && draggingFromGlobal !== listName && draggingFromGlobal !== ''}
                               additionalStyle={{marginBottom: '10px'}}>
                <DroppableList
                    list={secondaryGames}
                    // this ensures a dragged secondary game in merging is attributed to the merge initiator
                    setList={(e) => setSecondaryGames(prev => [{...e, game: {...e.game, pattern_secondary_game_user_id: userId}}, ...prev])}
                    itemType={'SECONDARY_GAMES'}
                    targetListName={listName}
                    sameItem={(item0, item1) => +item0.game.game_id === +item1.game.game_id}
                    noStyle
                    setDragging={(bool) => bool ?
                        dispatch({type: actionTypes.UPDATE_DRAGGING, name: listName})
                        : dispatch({type: actionTypes.UPDATE_DRAGGING, name: ''})
                    }
                />
            </PulsingDivWrapper>
        </div>
    </LibraryComponent>
}

export default ExampleGameTemporary